export const DATE_RANGE = {
  ANYTIME: "anytime",
  TODAY: "today",
  YESTERDAY: "yesterday",
  PAST_7_DAYS: "past_7_days",
  PAST_30_DAYS: "past_30_days",
  PAST_90_DAYS: "past_90_days",
} as const;
